/* Stackbin legacy gallery behavior, isolated from Symmetry core JavaScript. */
document.addEventListener('DOMContentLoaded', function () {
  const imageUrls = ["https://cdn.shopify.com/s/files/1/0553/9587/6961/files/Carhartt-1.png?v=1701965024", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/IMG_0516_1_480x480.jpg?v=1671731148", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/Quanta-1_600x600.png?v=1673884419", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/Mouser-ASRS-Station-1.png?v=1701974138", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/Amazon-Box-Shelf-1.png?v=1701974138", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/colossus.png?v=1701974137", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/lean-man-1.png?v=1701974136", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/Volvo-conveyor-1.png?v=1701974135", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/Instron-AT3.png?v=1701974131", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/DayPac-1.png?v=1701974131", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/Mouser-Over-Conveyor-1.png?v=1701974129", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/Toyota-packing-1.png?v=1701974128", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/VLM-1_969f5091-5922-40cc-9722-531dae1b9be4.png?v=1701974128", "https://cdn.shopify.com/s/files/1/0553/9587/6961/files/Volvo-assem-1.png?v=1701974114"];
  const containers = Array.from(document.querySelectorAll('.consultation-slideshow-con, .seth-slideshow-con'));
  if (!containers.length) return;

  const modal = document.querySelector('.tc-modal-con');
  const embed = document.querySelector('.tc-embed-container');
  const close = document.querySelector('.tc-close-modal');
  const left = document.querySelector('.tc-modal-con .left-button');
  const right = document.querySelector('.tc-modal-con .right-button');
  let selected = 0;

  function show(index) {
    if (!modal || !embed) return;
    selected = (index + imageUrls.length) % imageUrls.length;
    embed.replaceChildren();
    const image = document.createElement('img');
    image.src = imageUrls[selected];
    image.alt = '';
    embed.appendChild(image);
    modal.classList.add('active');
  }

  containers.forEach(function (container) {
    if (container.children.length) return;
    imageUrls.forEach(function (url, index) {
      const image = document.createElement('img');
      image.src = url;
      image.alt = '';
      image.className = 'indiv-slide';
      image.dataset.slideNumber = String(index);
      image.addEventListener('click', function () { show(index); });
      container.appendChild(image);
    });
  });

  if (left) left.addEventListener('click', function () { show(selected - 1); });
  if (right) right.addEventListener('click', function () { show(selected + 1); });
  if (close) close.addEventListener('click', function () {
    modal.classList.remove('active');
    if (embed) embed.replaceChildren();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal) {
      modal.classList.remove('active');
      if (embed) embed.replaceChildren();
    }
  });
});
